import { Paper, styled } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Tabs from 'components/ui/Tabs/UncontrolledTabs'
import { ReactNode } from 'react'

interface Props {
  labels: string[]
  children: ReactNode
  handleCopy?: (tabIdx: number) => void
}

const Container = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  height: '100%',
  margin: theme.spacing(3),
  overflow: 'hidden',
  position: 'relative',
}))

const useStyles = makeStyles({
  panel: {
    display: 'flex',
    flexFlow: 'column nowrap',
    height: '100%',
    overflow: 'hidden',
  },
})

function EditorTabs({ labels, children, handleCopy }: Props) {
  const styles = useStyles()
  return (
    <Container variant="outlined">
      <Tabs labels={labels} panelClassName={styles.panel} keepAlive handleCopy={handleCopy}>
        {children}
      </Tabs>
    </Container>
  )
}

export default EditorTabs
